import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useFilters } from '@/context/filters-context';

export const ServicesFilter = () => {
    const { filters, setFilters, filterConfig, facets } = useFilters();
    const serviceCounts = facets.services;
    const hasCounts = Object.keys(serviceCounts).length > 0;

    const handleChange = (key: string, checked: boolean) => {
        setFilters((prev) => ({
            ...prev,
            services: checked
                ? [...prev.services, key]
                : prev.services.filter((s) => s !== key),
        }));
    };

    // Hide services with zero profiles when facet counts are available.
    const visibleServices = hasCounts
        ? filterConfig.services.filter((s) => (serviceCounts[s.key] ?? 0) > 0)
        : filterConfig.services;

    if (!visibleServices.length) {
        return null;
    }

    return (
        <div className="space-y-2">
            {visibleServices.map((service) => (
                <div key={service.key} className="flex items-center space-x-2">
                    <Checkbox
                        id={`service-${service.key}`}
                        checked={filters.services.includes(service.key)}
                        onCheckedChange={(checked) => handleChange(service.key, checked as boolean)}
                    />
                    <Label htmlFor={`service-${service.key}`} className="text-sm">
                        {service.label}
                        {hasCounts && serviceCounts[service.key] !== undefined && (
                            <span className="ml-1 text-muted-foreground">({serviceCounts[service.key]})</span>
                        )}
                    </Label>
                </div>
            ))}
        </div>
    );
};
